import React, { useEffect, useState, useCallback } from "react";
import cx from "classnames";
import { BlockContent } from "src/components/block-content";
import { Media } from "src/components/media";
import { Collapse } from "@material-ui/core";

import { ReactComponent as PlusLarge } from "src/images/svg/PlusLarge.svg";
import { ReactComponent as ArrowRight } from "src/images/svg/ArrowRight.svg";

import * as styles from "./offerings.module.css";

interface SectionInterface {
	_key: string;
	copy: any[];
	bulletPoints: string[];
	titleSvg: {
		alt: string;
		asset: any;
	};
}

const Section = ({
	data,
	openByDefault,
}: {
	data: SectionInterface;
	openByDefault: boolean;
}) => {
	const [open, setOpen] = useState(openByDefault);

	return (
		<div className={styles.section}>
			<button
				onClick={() => setOpen(!open)}
				className={cx(
					"reset",
					styles.sectionTitleButton,
					open ? styles.open : ""
				)}
			>
				<img
					className={styles.sectionTitleButtonImg}
					src={data.titleSvg.asset.url}
					alt={data.titleSvg.alt}
				/>
				<PlusLarge className={styles.plus} />
			</button>
			<Collapse in={open}>
				<div className={styles.sectionContent}>
					<BlockContent className={cx("body ac")} blocks={data.copy} />
					{data.bulletPoints && (
						<ul className={styles.pointsList}>
							{data.bulletPoints.map((point, index) => (
								<li className={styles.pointsItem}>
									<ArrowRight className={cx(styles.pointsItemArrow)} />
									<span className={cx("body", styles.pointsItemCopy)}>
										{point}
									</span>
								</li>
							))}
						</ul>
					)}
				</div>
			</Collapse>
		</div>
	);
};

export interface SustainabilityOfferingsProps {
	headline: any[];
	sections: [SectionInterface];
}

export const SustainabilityOfferings = ({
	data,
}: {
	data: SustainabilityOfferingsProps;
}) => {
	const { headline, sections } = data;

	return (
		<div className={styles.offerings}>
			<BlockContent blocks={headline} className={cx("small-headline")} />
			{sections && (
				<div className={styles.accordion}>
					{sections.map((section, index) => (
						<Section
							data={section}
							openByDefault={index === 0}
							key={section._key}
						/>
					))}
				</div>
			)}
		</div>
	);
};
